import React from 'react'
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import { useForm, FormProvider} from "react-hook-form";
import IdentityApi from "../../../../Api/IdentityApi";
import { useHistory } from "react-router-dom";
import {getResponseError, getUserDetailsCookie} from "../../../../Api/Utils/apiUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";

const {
    heading,
    oldPassword,
    newPassword,
    confirmPassword,
    updatePasswordButton
} = formContent;

const ChangePasswordComponent = () => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const formBinding = useForm();
    const { watch,handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));
    const history = useHistory();
    const submitForm = async (data) => {
        const user = getUserDetailsCookie();
        const response = await IdentityApi.updatePassword(user.id, data.oldPassword, data.newPassword);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            history.push("/login");
        }
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="change-password-form" onSubmit={handleSubmit(submitForm)}>
                        <TextInput {...oldPassword} />
                        <TextInput {...newPassword} />
                        <TextInput {...confirmPassword} />
                        <Button {...updatePasswordButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default ChangePasswordComponent
